import { render } from "./P_Dualblades.vue?vue&type=template&id=3415e2da&scoped=true"
import script from "./P_Dualblades.vue?vue&type=script&lang=js"
export * from "./P_Dualblades.vue?vue&type=script&lang=js"

import "./P_Dualblades.vue?vue&type=style&index=0&id=3415e2da&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3415e2da"]])

export default __exports__